import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./lessonPageTour.css";

/**
 * Tour spotlight cho màn /elearning/lessons.
 * Các bước được gắn qua [data-tour] trong LessonFilter và thẻ bài học đầu tiên.
 */
function isDesktopLayout() {
  if (typeof window === "undefined" || !window.matchMedia) return true;
  return window.matchMedia("(min-width: 1024px)").matches;
}

export function startLessonPageTour() {
  const steps = [];
  const lg = isDesktopLayout();

  steps.push({
    popover: {
      title: "Hướng dẫn nhanh",
      description:
        "Vài bước giới thiệu giao diện Quản lý bài học. Bấm Tiếp để xem từng vùng, hoặc Đóng (X) để thoát bất cứ lúc nào.",
      side: "over",
      align: "center",
    },
  });

  const segments = [
    {
      selector: '[data-tour="lesson-course"]',
      title: "Chọn khóa học",
      description:
        "Bắt buộc chọn một khóa học để hệ thống tải đúng danh sách bài học (không tải toàn bộ khi mở trang).",
      side: "bottom",
    },
    {
      selector: '[data-tour="lesson-search"]',
      title: "Tìm bài học",
      description:
        "Gõ một phần tiêu đề; kết quả được lọc sau vài giây (không cần nhấn Enter).",
      side: "bottom",
    },
    {
      selector: '[data-tour="lesson-toolbar"]',
      title: "Tìm kiếm và làm mới",
      description: lg
        ? "Ô tìm theo tiêu đề (lọc sau vài giây) và nút làm mới để tải lại danh sách. Bước tiếp theo sẽ giới thiệu nút Thêm bài học và menu ⋮ bên phải."
        : "Ô tìm theo tiêu đề (lọc sau vài giây) và nút làm mới để tải lại danh sách từ máy chủ. Trên điện thoại, Thêm bài học và menu ⋮ đang ẩn — hãy dùng màn hình máy tính (hoặc xoay ngang nếu giao diện cho phép) khi cần các thao tác đó.",
      side: "bottom",
    },
    ...(lg
      ? [
          {
            selector: '[data-tour="lesson-toolbar-desktop"]',
            title: "Thêm bài học và menu",
            description:
              "Thêm bài học (nếu được phép) và menu ⋮ để mở hướng dẫn đầy đủ trong tab mới.",
            side: "bottom",
          },
        ]
      : []),
    {
      selector: '[data-tour="lesson-card-actions"]',
      title: "Trên mỗi thẻ bài học",
      description:
        "Tải bài giảng (ZIP), Trình chiếu bài giảng, và Xem giáo trình / tài liệu (PDF hoặc loại khác) — tùy tài liệu đã gắn.",
      side: "top",
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (el) {
      steps.push({
        element: el,
        popover: {
          title: seg.title,
          description: seg.description,
          side: seg.side,
        },
      });
    }
  }

  if (steps.length <= 1) {
    window.alert(
      "Chưa tải được các vùng giao diện để hướng dẫn. Hãy tải lại trang và thử lại."
    );
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "lesson-page-tour-popover",
    onPopoverRender: (popover) => {
      popover.wrapper?.setAttribute?.("lang", "vi");
    },
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
